import styled from 'styled-components';

export const ServiceName = styled.div`
  margin-right: ${({ theme }) => theme.spacing.base.sm};
  margin-top: ${({ theme }) => theme.spacing.base.xxs};
  opacity: 0.8;
  white-space: nowrap;
`;
